import { atom, useRecoilState } from 'recoil';

type UseHoveredModerationReportId = {
  hoveredReportId: number | null;
  setHoveredReportId: (id: number | null) => void;
};

const hoveredModerationReportIdAtom = atom<number | null>({
  key: 'HOVERED_MODERATION_REPORT_ID',
  default: null,
});

export const useHoveredModerationReportId =
  (): UseHoveredModerationReportId => {
    const [hoveredReportId, setHoveredReportIdState] = useRecoilState(
      hoveredModerationReportIdAtom,
    );

    return { hoveredReportId, setHoveredReportId: setHoveredReportIdState };
  };
